import Axios from '../baseApi';
export default {
  async addCarcase(query) {
    return await Axios.put(`/api-article/delivery-set/v1/carcases?${query}`);
  },
  addSummaryAddition(query, form) {
    return Axios.post(`/api-article/delivery-set/v1/carcases/add-summary-addition?${query}`, form);
  },
  async calcCaracases(query) {
    return await Axios.get(`/api-article/delivery-set/v1/calc/carcases?${query}`);
  },
  changeSummaryAddition(query, form) {
    return Axios.post(`/api-article/delivery-set/v1/carcases/set-summary-addition?${query}`, form);
  },
  changeSlaughterHouse(query, form) {
    return Axios.post(`/api-article/delivery-set/v1/carcases/change-slaughter-house?${query}`, form);
  },
  changeDeliveryProgram(query, form) {
    return Axios.post(`/api-article/delivery-set/v1/carcases/change-delivery-program?${query}`, form);
  },
  changeProducer(query, form) {
    return Axios.post(`/api-article/delivery-set/v1/carcases/change-producer?${query}`, form);
  },
  deleteProducer(query) {
    return Axios.delete(`/api-article/delivery-set/v1/carcases/delete-producer?${query}`);
  },
  async deleteCaracases(carcaseId, deliverySetId) {
    return await Axios.delete(`/api-article/delivery-set/v1/carcases/${carcaseId}/${deliverySetId}`);
  },
  async getTree(force) {
    return await Axios.get(`/api-article/delivery-set/v1/tree?forceReload=${force}`);
  },
  async getInfo(deliveryId) {
    return await Axios.get(`/api-article/delivery-set/v1/info/${deliveryId}`);
  },
  getOpenTransactions(deliveryId) {
    return Axios.get(`/api-article/delivery-set/v1/open-transactions/${deliveryId}`);
  },
  setOpenTransactions(deliveryId, data) {
    return Axios.post(`/api-article/delivery-set/v1/open-transactions/${deliveryId}`, data);
  },
  async getCaracases(query, forceReload) {
    return await Axios.get(`/api-article/delivery-set/v1/carcases?${query}&forceReload=${forceReload}`);
  },
  async merge(form) {
    return await Axios.post(`/api-article/delivery-set/v1/merge`, form);
  },
  async updateCarcase(query, form) {
    return await Axios.post(`/api-article/delivery-set/v1/carcases?${query}`, form);
  },
  async updatePrice(query, form) {
    return await Axios.post(`/api-article/delivery-set/v1/carcases/price?${query}`, form);
  },

  async updateMasterdata() {
    return await Axios.post(`/api-article/delivery-set/v1/update-masterdata`);
  },

  updateSummaryAddition(query, form) {
    return Axios.post(`/api-article/delivery-set/v1/carcases/update-summary-addition?${query}`, form);
  },
  async splitCaracases(query, form) {
    return await Axios.post(`/api-article/delivery-set/v1/carcases/split?${query}`, form);
  },
}
